import history from 'State/history';

export const navigateAndClose = (eventTracking, searchBarState, searchBarDispatch) => (url, doPush = false) => {
  eventTracking.logEvent('search > client > navigate', {
    navigateTo: url,
    searchesMade: searchBarState.searchesMade,
  });
  searchBarDispatch({
    type: 'closeSearchResults',
  });
  if (doPush) {
    history.push(url);
  }
};
